module.exports = __webpack_public_path__ + "img/default-snapshot-image.78c85e26.svg";